const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  fetchList: ({ commit }) => {
    let data = [
      {
        id: 1,
        title: 'New Score "Biology Chapter XI"',
        type: 'score',
        message:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores, cupiditate commodi ad doloribus incidunt vel officiis vero non dignissimos nihil. Odit officiis eum accusamus natus autem facere ex optio at?',
        createdAt: '1 minutes ago'
      },
      {
        id: 2,
        title: 'New Score "Biology Chapter XI"',
        type: 'submission',
        message:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores, cupiditate commodi ad doloribus incidunt vel officiis vero non dignissimos nihil. Odit officiis eum accusamus natus autem facere ex optio at?',
        createdAt: '1 minutes ago'
      }
    ];
    commit('SET_ITEM', data);
  },
  // eslint-disable-next-line no-unused-vars
  pustNotif({ rootGetters }, payload) {
    return window.axios.put(`api/notification`, {
      payload
    });
  },
  // eslint-disable-next-line no-unused-vars
  async fetchData({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/notification`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDataBirthday({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/notification/${id}/birthday`);
      return data;
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
